import Logger from '../../../common/logger';

let apiUrl = '';

export const Helpers = {
    getApiUrl: store => {
        if (apiUrl) {
            return apiUrl;
        }

        const state = store.getState();
        if (state.settings.env.botApis) {
            const drawBinary = ratio => {
                const drawedNumber = Math.random();
                if (drawedNumber > ratio) {
                    return 1;
                }
                return 0;
            };

            const apiIndex = drawBinary(state.settings.env.botApis.drawRatio);

            Logger.log(`getApiUrl: apiIndex=${apiIndex}`);

            apiUrl =
                apiIndex === 0 ? state.settings.env.botApis.url1 : state.settings.env.botApis.url2;
        } else {
            apiUrl = state.settings.env.botApiURL;
        }

        return apiUrl;
    },
    getApiTimeout: store => {
        const state = store.getState();
        return state.settings.botOptions && state.settings.botOptions.ApiTimeuot
            ? state.settings.botOptions.ApiTimeuot
            : 5;
    },
    getApiErrorMessage: store => {
        const state = store.getState();
        return state.settings.literals && state.settings.literals.botApiErrorMessage
            ? state.settings.literals.botApiErrorMessage
            : 'Nasz serwis jest chwilowo niedostępny. Przepraszamy, spróbuj ponownie później.';
    }
};
